import React from 'react';
import articleImage from '../../assets/images/article.png'
const ArticlePage = () => {
    return (
        <section className="w-full px-6 md:px-40 py-20 max-w-[1400px] mx-auto text-black">
            {/* Section 1: Left title, right text */}
            <div className="flex flex-col md:flex-row gap-16 ">
                {/* Left heading */}
                <div className="md:w-1/3">
                    <h2 className="text-7xl md:text-9xl font-black leading-tight uppercase font-bebas font-medium">The Ark of Life</h2>
                    <audio controls className="mt-6">
                        <source src="audio.mp3" type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                </div>

                {/* Right content */}
                <div className="md:w-2/3 flex flex-col gap-6 text-lg leading-relaxed font-open">
                    <p>
                        While prescient in the 1990s, it is far more prescient now simply because the
                        techniques we've got for editing DNA and for engineering DNA are so much
                        more advanced than they were just a few decades ago,” said Maynard, a
                        professor at ASU’s School for the Future of Innovation in Society.. “Yet we're
                        still struggling to understand what the consequences of our actions are.
                    </p>
                    <p>
                        When Jennifer Doudna and Emmanuelle Charpentier co-discovered CRISPR
                        a decade ago, it was a basic discovery of a million-year-old, cat-and-mouse
                        game used by bacteria to fend off viruses.
                    </p>
                    <p>
                        When Jennifer Doudna and Emmanuelle Charpentier co-discovered CRISPR
                        a decade ago, it was a basic discovery of a million-year-old, cat-and-mouse
                        game used by bacteria to fend off viruses.
                    </p>
                    <p>
                        With that mechanism, it became clear to Doudna and Charpentier the true
                        power of CRISPR was the way it could edit DNA.
                    </p>
                    <p>
                        “And, once we understood the mechanism, we were able to precisely
                        engineer where we can create certain changes in the genome,” said Tsosie.
                    </p>
                    <p>Tsosie points out that CRISPR comes from a long line of molecular tools,
                        beginning in the 1970s, that can snip, edit, or change the genetic code. In lab
                        research, it was used to study the impact of gene mutations to get at the
                        heart of the function of a particular gene.</p>
                    <p>“That’s the beauty of a tool like CRISPR when it's kept at the small scale in
                        the lab,” added Tsosie, an assistant professor in the School of Life Sciences
                        at Arizona State University.</p>
                    <div className="border-t-4 border-red-500 w-full mb-20 mt-24 " />
                </div>
            </div>

            {/* Divider */}

            {/* Section 2: A Simple Cell */}
            <div className="flex flex-col md:flex-row gap-16 ">
                {/* Left heading */}
                <div className="md:w-1/3">
                    <h2 className="text-6xl md:text-7xl font-black leading-tight uppercase font-bebas md:text-right font-medium" >A Simple Cell</h2>
                    {/* Image block */}
                    <div className="flex  my-6">
                        <div className=" h-65 overflow-hidden border-2 border-white shadow-lg">
                            <img src={articleImage} alt="Kerry Geller-Samorette" className="w-full h-full object-cover" />
                        </div>
                    </div>
                    <p className="text-sm text-gray-500">Kerry Geller-Samorette</p>
                </div>

                <div className="md:w-2/3 flex flex-col gap-6 text-lg leading-relaxed font-open">
                    <p>
                        CRISPR has certainly transformed genetic lab research. Driven by CRISPR,
                        many scientists have begun “directed evolution” projects, first on simpler,
                        single-celled lab organisms.
                    </p>
                    <p>
                        Researcher Kerry Geiler-Samerotte studies baker’s yeast, the stuff that helps
                        make bread and beer, invented some 7,000 years ago.
                    </p>
                    <p>
                        “I chose to focus on yeast,” said Geiler-Samerotte. “It has to do with the
                        question that I'm interested in, understanding the impacts of mutations.”
                    </p>
                    <p>
                        All of life is made of DNA, mixed and shuffled like a deck of cards before being
                        passed on to every organism’s offspring. The randomness of that shuffling is
                        what makes us unique.
                    </p>
                    <p>
                        The complete book of all the human chemical letters of DNA is 3 billion pearly
                        beads long.
                    </p>
                    <p>
                        We are talking about big data here. A single human genome, printed page by
                        page, letter by letter, would fill more than 175 books, or 262,000 densely
                        printed pages.
                    </p>
                    <p>
                        “And since then, we've sequenced thousands, maybe even hundreds of
                        thousands of human genomes and the genomes of all the little critters that
                        can infect us,” said Geiler-Samerotte.
                    </p>
                    <p>
                        Fast forward to today.
                    </p><p>
                        As of today, nearly 4,000 unique animals have had their genomes sequenced.
                        These days, computers and software do the heavy lifting. Databanks for
                        storing the DNA codes are made publicly available in the National Center for
                        Biotechnology Information (NCBI) GenBank database.
                    </p>
                    <p>
                        While this may seem like a lot, it equals just 0.2% of all animal species.
                    </p>
                    <p>
                        “And I think it's, it's a little bit infuriating that we don't know more about what
                        changing these genomes does to us,” said Geiler-Samerotte, an assistant
                        professor in the Biodesign Institute’s Center for Mechanisms of Evolution and
                        the School of Life Sciences at Arizona State University.
                    </p>
                    <p>
                        Figuring out what all those mutations do has been called one of the top 10
                        grand challenges of biology.
                    </p>
                    <div className="border-t-4 border-red-500 w-full mb-20 mt-24 " />


                </div>
            </div>
            <div className="flex flex-col md:flex-row gap-16 ">
                {/* Left heading */}
                <div className="md:w-1/3">
                    <h2 className="text-6xl md:text-7xl font-black leading-tight uppercase font-bebas md:text-right font-medium">A NOT-SO-SIMPLE Fate</h2>
                </div>

                {/* Right content */}
                <div className="md:w-2/3 flex flex-col gap-6 text-lg leading-relaxed font-open">
                    <p>
                        Her lab quantifies the impact of wholesale CRISPR mutations may have on
                        cell physiology and growth across very fine and controllable environmental
                        gradients---like the food or carbon source of yeast diets, or their temperature
                        and oxygen levels.
                    </p>
                    <p>
                        A major goal is to understand and predict when and why the impacts of these
                        mutations change across contexts.
                    </p>
                    <p>
                        When it comes to figuring out the consequences of those mutations,
                        sometimes, it has led to surprising results.
                    </p>
                    <div className="border-t-4 border-red-500 w-full mb-20 mt-24 " />

                </div>
            </div>
            <div className="flex flex-col md:flex-row gap-16">
                {/* Left heading */}
                <div className="md:w-1/3">
                    <h2 className="text-6xl md:text-7xl font-black leading-tight uppercase font-bebas md:text-right font-medium">NUMBERS GAME</h2>
                </div>

                {/* Right content */}
                <div className="md:w-2/3 flex flex-col gap-6 text-lg leading-relaxed font-open">
                    <p>
                        “One thing we've learned recently from our studies is that a lot of these
                        mutations can have hidden effects,” she explained. “So, you think you
                        understand what a mutation does. You think, okay, this mutation is in a
                        glucose sensing pathway. It helps the organism understand how much
                        nutrients are available in the environment.”
                    </p>
                    <p>
                        “What we found is that even those similar seeming mutations can have latent
                        effects. One of them might affect your growth in a high salt environment, and
                        the other one might not. That makes the problem even more confusing,
                        because now it's not just what this mutation does in a glucose-limited
                        environment, it's what all the things this mutation does.
                    </p>
                    <p>
                        One of the conclusions [we made] is that evolution is dependent on what's
                        come before on chance and contingency. That’s because if mutations have
                        latent effects, whether a organism thrives in a new environment depends on
                        whether previously made mutations happen to provide advantages or
                        disadvantages in that environment.”
                    </p>
                    <p> Even in trying to direct the evolution of yeast, life is left to chance.</p>
                    <p>If scientists can’t predict how mutations will affect the fitness of yeast, what
                        hope is there for bringing back the wooly mammoth from extinction, or editing
                        other life, including us?</p>
                    <p>
                        “The perspective that I can give really has to do with the complexity of
                        genomes and how I think we are far away from things like designer babies,”
                        said Geileor-Samerotte, “because we wouldn't know what edits to make to
                        even be able to offer that.”
                    </p>
                    <p>
                        Until now, evolution was under control by the forces of nature.
                    </p>
                    <p>
                        But with humans, about 10,000 years ago, we began to selectively breed and
                        domesticate animals and plants. We have increasingly played a direct role in
                        the way animals and plants evolve.
                    </p>
                    <p>
                        Now with CRISPR, we have the capacity to direct the evolution of potentially
                        all life on Earth.
                    </p>
                    <p>In animals, CRISPR is being used to understand the colors and patterns in
                        butterfly wings. CRISPR-edited pigs are being bred to provide potential human
                        organ transplants. Mice are being introduced with genes from the human
                        voice box (no, they don’t talk, but yes, they squeak differently).</p>
                    <p>“The potential utility of CRISPR right now is very limited by the fact that we
                        don't understand a lot about the genome and what mutations do,”
                        Geiler-Samerotte said. “But it's been very helpful in helping us gain that
                        understanding.”</p>
                    <div className="border-t-4 border-red-500 w-full mb-20 mt-24 " />

                </div>
            </div>
            <div className="flex flex-col md:flex-row gap-16 ">
                {/* Left heading */}
                <div className="md:w-1/3">
                    <h2 className="text-6xl md:text-7xl font-black font-bebas leading-tight uppercase md:text-right font-medium">DO WE HAVE THE
                        TECHNOLOGY?</h2>
                </div>

                {/* Right content */}
                <div className="md:w-2/3 flex flex-col gap-6 text-lg leading-relaxed font-open">
                    <p>
                        Meanwhile, the tale of the Colossal Genomics wooly mammoth project has
                        captivated the public’s imagination, but also opened an ethical debate on
                        could and should we bring back endangered species.
                    </p>
                    <p>
                        The company is led by George Church and Beth Shapiro, leaders in the field of
                        DNA genomics. They started it as a side project, a sort of a hobby from their
                        main research, but now investors have contributed $15 million to accelerate
                        the research to make it a reality.
                    </p>
                    <p>
                        The Colossal Genomics website states, boldly in all caps:
                    </p>
                    <p> “MAY PREHISTORY THUNDER FORWARD. WE HAVE THE DNA, THE
                        TECHNOLOGY AND THE LEADING EXPERTS IN THE FIELD. NEXT, WE WILL
                        HAVE THE WOOLY MAMMOTH. ALIVE AGAIN.”</p>
                    <p>The wooly mammoth project is promised as the first of many to solve a
                        “colossal problem facing the world,” extinction.</p>
                    <p>
                        “I worry that for lots of species today, the pace of climate change and the
                        pace of habitat degradation is such that evolution isn’t going to be able to
                        save them,” Shapiro says within the Colossal website. “We need to intervene
                        even more.”
                    </p>
                    <p>
                        Scientists also may be able to use Colossal’s advances to save species under
                        threat from diseases by endowing them with genes that make them more
                        resistant to disease or resilient to climate change.
                    </p>
                    <p>
                        We are faced with some urgent questions. Ultimately, which ones can we
                        save? Which ones should we save? With CRISPR technology, we may no
                        longer have to choose.
                    </p>


                </div>
            </div>
        </section>
    );
};

export default ArticlePage;
